import { inject } from '@angular/core';
import { SidebarService } from './sidebar/data-access/sidebar.service';
import { offset } from '@floating-ui/dom';
import {
  concatMap,
  from,
  of,
  Subscription,
  switchMap,
  filter,
  take,
  tap,
  firstValueFrom,
  delay
} from 'rxjs';
export const createTour = (tour) => {
  const sidebarService = inject(SidebarService);

  const beforeShowGuard = () => {
   sidebarService.open();

        return firstValueFrom(
          sidebarService.opened$.pipe(filter((opened) => opened === true))
        ).then(() => undefined);

  };
  tour.addSteps([
    {
      title: 'Help - Welcome',
      text: 'This page is used to manage the layers shown on the map.',
      arrow: { padding: -20 },
      attachTo: {
        element: "[data-tour='sidebar-content']",
        on: 'left'
      },
      beforeShowPromise: beforeShowGuard,
      buttons: [
        {
          text: 'Next',
          action: tour.next
        }
      ],
      floatingUIOptions: {
        middleware: [offset({ mainAxis: 0, crossAxis: -24 })]
      },
      when: {
        show: () => {
          sidebarService.toggleComponentItem('layers');
        }
      }
    },
    {
      title: 'Help - Welcome',
      text: 'This page is used to create a property in the system.',
      attachTo: {
        element: "[data-tour='sidebar-content']",
        on: 'left'
      },
      beforeShowPromise: beforeShowGuard,
      buttons: [
        {
          text: 'Next',
          action: tour.next
        }
      ],
      when: {
        show: () => {
          sidebarService.toggleComponentItem('create-property');
        }
      },
    },
     {
      title: 'Help - Welcome',
      text: 'This page is used to create a property in the system.',
      attachTo: {
        element: "[data-tour='sidebar-content']",
        on: 'left'
      },
      beforeShowPromise: beforeShowGuard,
      buttons: [
        {
          text: 'Next',
          action: tour.next
        }
      ],
      when: {
        show: () => {
          sidebarService.toggleComponentItem('manage-properties');
        }
      },
    }
  ]);
};

